module.exports = __webpack_public_path__ + "static/img/megaphone1.8b9050be.png";